import en from "./en";
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

export const defaultNS = "common";

i18next.use(initReactI18next).init({
  lng: "en", // if you're using a language detector, do not define the lng option
  // debug: import.meta.env.MODE === "development",

  resources: {
    en,
  },
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});
